function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@finect/tabular-core/Button';
import { dataLayer } from '@finect/front-gtm';
import { TextButton } from '@finect/tabular-core/TextButton';
import { ShoppingCart } from '@finect/tabular-icons/shoppingCart';
import { getProductAction, getProductPath, getProductTypesByCategory } from '@finect/front-resources/Products';
import { HiddenText } from '../../../../HiddenText';
import { StyledBuyButton } from './partials';
var VARIANTS = {
  textButton: {
    component: TextButton,
    withLabel: false,
    withIcon: true
  },
  button: {
    component: Button,
    withLabel: true,
    withIcon: false,
    width: 'auto',
    size: 'small'
  },
  cta: {
    component: Button,
    height: '42px',
    withLabel: true,
    withIcon: false,
    width: '100%',
    size: 'medium'
  }
};
var SHOW_ONLY_IF_SAME_CLASS = ['mapfre-gestion-patrimonial-agentes'];
export var BuyButton = function BuyButton(_ref) {
  var _product$commercializ;
  var onAction = _ref.onAction,
    product = _ref.product,
    variant = _ref.variant,
    _ref$withSPA = _ref.withSPA,
    withSPA = _ref$withSPA === void 0 ? false : _ref$withSPA,
    _ref$context = _ref.context,
    context = _ref$context === void 0 ? [] : _ref$context;
  var entity = product.entity;
  var commercializations = product === null || product === void 0 ? void 0 : (_product$commercializ = product.commercializations) === null || _product$commercializ === void 0 ? void 0 : _product$commercializ.filter(function (_ref2) {
    var organization = _ref2.organization,
      security = _ref2.security,
      affiliate = _ref2.affiliate;
    return affiliate.link && (!SHOW_ONLY_IF_SAME_CLASS.includes(organization.alias) ? true : security.isin === entity.isin);
  });
  var buyButtonProps = _defineProperty({
    title: entity.transactionable ? "M\xE1s informaci\xF3n acerca de ".concat(entity.name) : 'Producto no disponible',
    disabled: !entity.transactionable || (commercializations === null || commercializations === void 0 ? void 0 : commercializations.length) === 0,
    onClick: entity.transactionable ? onAction : function () {}
  }, entity.transactionable ? 'secondary' : 'terciary', true);
  var _VARIANTS$variant = VARIANTS[variant],
    component = _VARIANTS$variant.component,
    withLabel = _VARIANTS$variant.withLabel,
    withIcon = _VARIANTS$variant.withIcon,
    _VARIANTS$variant$wid = _VARIANTS$variant.width,
    width = _VARIANTS$variant$wid === void 0 ? 'auto' : _VARIANTS$variant$wid,
    _VARIANTS$variant$siz = _VARIANTS$variant.size,
    size = _VARIANTS$variant$siz === void 0 ? 'small' : _VARIANTS$variant$siz,
    _VARIANTS$variant$hei = _VARIANTS$variant.height,
    height = _VARIANTS$variant$hei === void 0 ? null : _VARIANTS$variant$hei;
  var action = getProductAction(product);
  var handleMoreInfo = function handleMoreInfo(evt) {
    var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    !withSPA && evt.preventDefault();
    var path = getProductPath(product, context || []);
    var layer = {
      id: 'ProductCard',
      type: 'productClick',
      params: {
        product: product,
        position: null,
        element: element
      },
      callback: withSPA ? undefined : function () {
        window.location = "".concat(path);
      }
    };
    dataLayer(layer);
  };
  var iicProducts = getProductTypesByCategory('iic').map(function (_ref3) {
    var id = _ref3.id;
    return id;
  });
  var path = getProductPath(product, context || []);
  var nameLinkProps = iicProducts.includes(product.subtype) && !(product.isin || product.entity.isin) ? {
    disabled: true
  } : withSPA ? {
    as: Link,
    to: path
  } : {
    as: 'a',
    href: path,
    target: '_top'
  };
  return onAction ? React.createElement(StyledBuyButton, _extends({
    as: component,
    width: width,
    height: height,
    variant: size
  }, buyButtonProps), React.createElement("span", null, withIcon ? React.createElement(ShoppingCart, {
    size: "18",
    strokeWidth: "2.5"
  }) : null, withLabel ? action.action : null)) : React.createElement(Button, _extends({
    secondary: "true",
    width: "100%",
    onClick: function onClick(event) {
      handleMoreInfo(event, 'moreInfo');
    },
    title: buyButtonProps.title
  }, nameLinkProps), "M\xE1s informaci\xF3n ", React.createElement(HiddenText, null, "acerca de ", entity.name));
};